import Select from 'react-select'
import styled from 'styled-components'

export const SelectField = styled(Select)`
  & .Select__input > input {
    width: 100% !important;
  }
`
